<template>
  <div id="app">
    <div id="nav" class="sidebar" v-if="currentRoute !== '/login'">
      <div class="sidebar-header align-center">
        <img class="sidebar-logo-small" src="./assets/logo-small.png" height="60" alt="Logo">
      </div>
      <div class="sidebar-menu-items">
        <ul class="menu-list">
          <router-link active-class="is-active" to="/" exact el="li">
            <b-tooltip label="Home" position="is-right" type="is-light">
                <b-icon icon="home" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/topics" el="li">
            <b-tooltip label="Menus" position="is-right" type="is-light">
                <b-icon icon="ellipsis-h" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/feeds" el="li">
            <b-tooltip label="Feeds" position="is-right" type="is-light">
                <b-icon icon="database" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/articles" el="li">
            <b-tooltip label="Articles" position="is-right" type="is-light">
                <b-icon icon="newspaper" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/videos" el="li">
            <b-tooltip label="Videos" position="is-right" type="is-light">
                <b-icon icon="video" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/tools" el="li">
            <b-tooltip label="Tools" position="is-right" type="is-light">
                <b-icon icon="hammer" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/pages" el="li">
            <b-tooltip label="Pages" position="is-right" type="is-light">
                <b-icon icon="file" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
          <router-link active-class="is-active" to="/logout" el="li">
            <b-tooltip label="Sign Out" position="is-right" type="is-light">
                <b-icon icon="sign-out-alt" size="is-small"></b-icon>
            </b-tooltip>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="content-section">
      <div class="section">
        <div class="container">
          <transition name="fade" mode="out-in">
            <!-- this is where our components will be injected -->
            <router-view></router-view>   
          </transition>        
        </div>
      </div>
    </div>

    <notifications position='bottom right'></notifications>
  </div>
</template>

<script>
export default {
  mounted() {
    const { $router } = this;

    // keyboard shortcuts for navigation
    document.onkeyup = function(e) {
      // ctrl + alt
      if (e.ctrlKey && e.altKey && e.which) {
        // t
        if (e.which === 84) $router.push("topics");
        // f
        else if (e.which === 70) $router.push("feeds");
        // a
        else if (e.which === 65) $router.push("articles");
        // v
        else if (e.which === 86) $router.push("videos");
        // e
        else if (e.which === 69) $router.push("explorer");
      }
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  },
};
</script>


<style lang="scss">
.sidebar {
  background-color: white;
  width: 65px;
  height: 100vh;
  position: fixed;
  left: 0px; // change this to hide
  // transition: all 0.45s;
  z-index: 999;
  box-shadow: 5px 12px 20px rgba(36, 37, 38, 0.13);
}

.content-section {
  width: calc(100vw - 65px);
  margin-left: 65px;
  // transition: all 0.45s;
}

#nav > .sidebar-menu-items > ul > a {
  font-size: 20px;
}

.sidebar-header {
  height: 60px;
  background-color: #0055a5;
}

.sidebar-menu-items {
  padding: 10px;
}

.sidebar-logo {
  height: 60px;
  max-height: 60px;
}

.sidebar-logo-small{
  height: 40px;
  margin-top: 10px;
}

.align-center {
  text-align: center;
}
</style>
